/**
 * Created by User on 02/03/2016.
 */
import Observer from '../utils/Observer';
import AdConsts from '../AdConsts';

export default ExternalEventsDispatcher;

function ExternalEventsDispatcher(playlist) {
  var _playlist = playlist;

  this.dispose = function() {
    _playlist = null;
    Observer.off(_events, _onEvent);
  };

  var _onEvent = function(event) {
    var member, count, number, data;
    member = _playlist.currentBlock ? _playlist.currentBlock.currentMember : null;
    if (member) {
      count = _playlist.getMembersCount(member);
      number = _playlist.getMemberNumber(member);
      data = { 'count': count, 'number': number, 'type': member.type, 'mediaURL': member.mediaFileUrl,
        'xmlURL': member.loadedXMLURL, linear: member.linear, 'analyticsTag': member.analyticsTag,
        'elementURL': null, 'vastData': null };
      if (member.element) {
        data.elementURL = member.element.url;
        data.vastData = member.element.vastData;
      }
    } else {
      data = {};
      if (_playlist.currentBlock) {
        data.type = _playlist.currentBlock.type;
        data.linear = _playlist.currentBlock.linear;
      }
    }
    switch (event.name) {
      case AdConsts.PLAYLIST_READY:
        Observer.emit(AdConsts.AD_PLAYLIST_LOADING_COMPLETE, data);
        break;
      case AdConsts.PLAYLIST_ERROR:
        Observer.emit(AdConsts.AD_PLAYLIST_LOADING_ERROR, data);
        break;
      case AdConsts.MEMBER_STARTED_DE_FACTO:
        Observer.emit(AdConsts.AD_MEMBER_STARTED_PLAYING, data);
        break;
      case AdConsts.MEMBER_BEGIN_LOADING:
        Observer.emit(AdConsts.AD_MEMBER_STARTED_LOADING_NEW_URL, data);
        break;
      case AdConsts.MEDIAFILE_TIMEOUT:
        Observer.emit(AdConsts.AD_MEDIA_LOADING_TIMEOUT, data);
        break;
      case AdConsts.XML_TIMEOUT:
        Observer.emit(AdConsts.AD_XML_LOADING_TIMEOUT, data);
        break;
      case AdConsts.NOBANNER:
        Observer.emit(AdConsts.AD_NOBANNER, data);
        break;
      case AdConsts.DUPLICATE_MEDIAFILE:
        Observer.emit(AdConsts.AD_DUPLICATE_MEDIA, data);
        break;
      case AdConsts.ELEMENT_CREATING_SUCCESS:
        if (event.data && event.data.vastData) {
          data.vastData = event.data.vastData;
          Observer.emit(AdConsts.AD_VAST_DATA, data);
        }
        break;
      case AdConsts.XML_LOADED:
        data.loadingTime = event.data;
        Observer.emit(AdConsts.AD_XML_LOADING_TIME, data);
        break;
      case AdConsts.BLOCK_STARTED:
        var block = _playlist.currentBlock;
        if (block && block.extended === false) {
          Observer.emit(AdConsts.AD_BLOCK_STARTED, data);
        }
        break;
      case AdConsts.PAGE_CLOSING:
        if (member) {
          Observer.emit(AdConsts.AD_CLOSING_ON_RUNNING_AD, data);
        }
        break;
      case AdConsts.VAST_EVENT:
        data.vastEvent = event.data;
        Observer.emit(AdConsts.AD_VAST_EVENT, data);
        break;
      case AdConsts.XML_INVALID:
        Observer.emit(AdConsts.AD_VAST_XML_INVALID, data);
        break;
      case AdConsts.MEDIA_BEGINS_LOADING:
        Observer.emit(AdConsts.AD_MEDIA_BEGINS_LOADING, data);
        break;
      case AdConsts.BLOCK_ENDED:
        Observer.emit(AdConsts.AD_COMPLETE, data);
        break;
      case AdConsts.XML_LOADING_ERROR:
        Observer.emit(AdConsts.AD_XML_LOADING_ERROR, data);
        break;
      case AdConsts.XML_PARSING_ERROR:
        Observer.emit(AdConsts.AD_VAST_XML_INVALID, data);
        break;
      case AdConsts.MEDIAFILE_VENDOR_ERROR:
        Observer.emit(AdConsts.AD_MEDIAFILE_VENDOR_ERROR, data);
        break;
      case AdConsts.CANNOT_FIND_VENDOR:
        Observer.emit(AdConsts.AD_CANNOT_DISPLAY_MEDIAFILE, data);
        break;
      case AdConsts.GOOGLE_IN_VAST:
        Observer.emit(AdConsts.AD_GOOGLE_IN_VAST, data);
        break;
      case AdConsts.BLOCK_STARTING_NEW_ELEMENT:
        Observer.emit(AdConsts.AD_MEMBER_IS_STARTING, data);
        break;
    }
  };

  var _events = [
    AdConsts.PLAYLIST_READY,
    AdConsts.PLAYLIST_ERROR,
    AdConsts.MEDIAFILE_TIMEOUT,
    AdConsts.XML_TIMEOUT,
    //AdConsts.BLOCK_STARTED_DE_FACTO,
    AdConsts.NOBANNER,
    AdConsts.DUPLICATE_MEDIAFILE,
    AdConsts.ELEMENT_CREATING_SUCCESS,
    AdConsts.MEMBER_STARTED_DE_FACTO,
    AdConsts.XML_LOADED,
    AdConsts.MEMBER_BEGIN_LOADING,
    AdConsts.BLOCK_STARTED,
    AdConsts.PAGE_CLOSING,
    AdConsts.VAST_EVENT,
    AdConsts.XML_INVALID,
    AdConsts.MEDIA_BEGINS_LOADING,
    AdConsts.BLOCK_ENDED,
    AdConsts.XML_LOADING_ERROR,
    AdConsts.XML_PARSING_ERROR,
    AdConsts.MEDIAFILE_VENDOR_ERROR,
    AdConsts.CANNOT_FIND_VENDOR,
    AdConsts.GOOGLE_IN_VAST,
    AdConsts.BLOCK_STARTING_NEW_ELEMENT,
  ];
  Observer.on(_events, _onEvent);
}
ExternalEventsDispatcher.prototype.constructor = ExternalEventsDispatcher;
